export default 
[
  {
    id: 0,
    sigla: "---",
    nome: "---"
  },
  {
    id: 1,
    sigla: "JAN",
    nome: "Janeiro"
  },
  {
    id: 2,
    sigla: "FEV",
    nome: "Fevereiro"
  },
  {
    id: 3,
    sigla: "MAR",
    nome: "Março"
    },
  {
    id: 4,
    sigla: "ABR",
    nome: "Abril"
  },
  {
    id: 5,
    sigla: "MAI",
    nome: "Maio"
  },
  {
    id: 6,
    sigla: "JUN",
    nome: "Junho"
  },  {
    id: 7,
    sigla: "JUL",
    nome: "Julho"
  },
  {
    id: 8,
    sigla: "AGO",
    nome: "Agosto"
  },
  {
    id: 9,
    sigla: "SET",
    nome: "Setembro"
  },
  {
    id: 10,
    sigla: "OUT",
    nome: "Outubro"
  },
  {
    id: 11,
    sigla: "NOV",
    nome: "Novembro"
  },
  {
    id: 12,
    sigla: "DEZ",
    nome: "Dezembro"
  },
]



// WEBPACK FOOTER //
// ./FrontEnd/js/mesesano.js